import styled from "styled-components";

export const Main = styled.div`
  min-width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  width: 350px;

  .actions {
      gap: 10px;
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
      }
    }

  .textInput {
    margin-bottom: 10px;

    h4 {
      width: 110px;
    }
  }
  .one {
    margin-top: 20px !important;
  }
  .switch {
    justify-content: center;
    margin-top: 7.5px;
    margin-bottom: 10px;
  }
  .note {
    font-size: 13px;
    color: #4b5563;
    line-height: 1.4;
    margin-top: 6px;
    text-align: center;
  }
`;